import script from "./dynamicView.vue?vue&type=script&lang=ts&setup=true"
export * from "./dynamicView.vue?vue&type=script&lang=ts&setup=true"

import "./dynamicView.vue?vue&type=style&index=0&id=6de69ed6&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/miyo-prod/ftrc-prd/src/project/fotile-riskctl/code/frontend/mgr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6de69ed6"]])

export default __exports__